import React, { useRef } from 'react'
import { Grid } from '@material-ui/core'
import PropTypes from 'prop-types'
import Card from '../../../../../molecules/Card'
import InlineCardHeader from '../../../../../molecules/Card/InlineCardHeader'
import SydButton from '../../../../../commonDesign/Button'
import EditDatapointDialog from '../../dialogs/EditDatapointDialog'
import DescribeDatapointDialog from '../../dialogs/DescribeDatapointDialog'
import DataSourceAttributes from '../shared/DatasourceAttributes'
import DatasourceActionsMenu from '../shared/DatasourceActionsMenu'
import DatasourceDescription from '../shared/DatasourceDescription'
import DatapointsTable from './DatapointsTable'

function DetailsTab ({ datasource }) {
  const editDatapointsRef = useRef(null)
  const describeDatapointDialog = useRef(null)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader
            action={(
              <DatasourceActionsMenu datasource={datasource} />
            )}
          >
            Details
          </InlineCardHeader>
          <DataSourceAttributes datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card>
          <InlineCardHeader>Description</InlineCardHeader>
          <DatasourceDescription datasource={datasource} />
        </Card>
      </Grid>
      <Grid item xs={12}>
        <Card>
          <InlineCardHeader action={<SydButton size='sm' icon='edit' onClick={() => editDatapointsRef.current.open(datasource)}>Edit</SydButton>}>Datapoints</InlineCardHeader>
          <DatapointsTable datapoints={datasource.datapoints} onAccessorClick={(dp) => describeDatapointDialog.current.open(datasource, dp)} />
          <EditDatapointDialog ref={editDatapointsRef} />
          <DescribeDatapointDialog ref={describeDatapointDialog} />
        </Card>
      </Grid>
    </Grid>
  )
}

DetailsTab.propTypes = {
  datasource: PropTypes.any
}

export default DetailsTab
